import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { getGemsTokenContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const useApproveGems = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.gems;
  const presaleAddress = Environment.presaleContract;
  const contract = getGemsTokenContract(tokenAddress, web3);

  const approveGems = useCallback(
    async (amount) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");
      const nd = web3.utils.toWei(amount.toString(), "ether");

      try {
        return new Promise(async (resolve, reject) => {
          let gas;
          try {
            gas = await contract.methods.approve(presaleAddress, nd).estimateGas({
              from: account,
            });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .approve(presaleAddress, nd)
            .send({ from: account, gas })
            .on("transactionHash", (hash) => {
              console.log("Approval tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("Approval confirmed:", receipt);
              resolve({ transactionHash: receipt.transactionHash, receipt });
            })
            .on("error", (error) => {
              console.error("Approval failed:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3]
  );

  return { approveGems };
};

export default useApproveGems;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { getGemsTokenContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";

// const ApproveGems = () => {
//   const [balance, setBalance] = useState(null);
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.gems;
//   const tokenAddress1 = Environment.presaleContract;
//   const contract = getGemsTokenContract(tokenAddress, web3);

//   const approveGems = useCallback(
//     async (amount) => {
//       try {
//         let nd = web3.utils.toWei(amount.toString(), "ether");
//         // let gasPrice = await web3.eth.getGasPrice();
//         // gasPrice = parseInt(gasPrice) + 5000000000;
//         const gas = await contract.methods
//           .approve(tokenAddress1, nd)
//           .estimateGas({ from: account });
//         // let gasPrice = await web3.eth.getGasPrice();
//         const details = await contract.methods.approve(tokenAddress1, nd).send({
//           from: account,
//           gas: gas,
//           // gasPrice,
//         });
//         return details;
//         // console.log('sdsdss' ,  buy)
//         // return details;
//       } catch (error) {
//         throw error;
//       }
//     },
//     [contract, account, web3]
//   );
//   return { approveGems: approveGems };
// };
// export default ApproveGems;
